import styles from "./custom-badge.module.scss";

const cx = (...xs) => xs.filter(Boolean).join(" ");

const CustomBadge = ({
	as = "span",
	variant = "neutral",
	size = "md",
	pill = true,
	dot = false,
	startIcon,
	endIcon,
	children,
	className,
	href,
	onClick,
	ariaLabel,
	style,
	...rest
}) => {
	const Tag = href ? "a" : as;

	const classes = cx(styles.badge, styles[variant], styles[size], pill && styles.pill, (href || onClick) && styles.interactive, className);

	const content = (
		<>
			{dot && <span className={styles.dot} aria-hidden="true" />}
			{startIcon && <span className={styles.icon}>{startIcon}</span>}
			{children && <span className={styles.label}>{children}</span>}
			{endIcon && <span className={styles.icon}>{endIcon}</span>}
		</>
	);

	const sharedProps = {
		className: classes,
		"aria-label": ariaLabel,
		style,
		...rest,
	};

	if (href) {
		return (
			<Tag href={href} {...sharedProps}>
				{content}
			</Tag>
		);
	}

	return (
		<Tag onClick={onClick} {...sharedProps}>
			{content}
		</Tag>
	);
};

export default CustomBadge;
